import { Link } from "react-router-dom";
import { ArrowBigRight, BriefcaseBusiness, Building2 } from "lucide-react";
import { formatCurrency, formatDate } from "@/common/utils/formatters";
import { billingEventsFiscalDocumentsStatus } from "../constants/eventsFiscalDocumentsStatusOptions.constant";
import { FiscalDocumentGroupData } from "../types/fiscalDocumentGroup.type";
import { ImageWithPlaceholder } from "@/common/components/ImageWithPlaceholder";

export class BillingFiscalDocumentGroupsTransformer {
  static tableTransformer() {
    return (groups: FiscalDocumentGroupData[]) => {
      return groups.map((group) => {
        return {
          ...group,
          status: group.status ? billingEventsFiscalDocumentsStatus[group.status as keyof typeof billingEventsFiscalDocumentsStatus] : '',
          client_company: group?.client_branch?.general_information && (
            <div className="flex items-center gap-2">
              <ImageWithPlaceholder
                placeholderIcon={BriefcaseBusiness}
                className="w-6 h-6"
                iconClassName="w-4 h-4"
                url={group?.client_branch?.general_information?.company_logo?.url}
              />

              <p>
                {group?.client_branch?.general_information?.fantasy_name}
              </p>
            </div>
          ),
          client_company_branch: group?.client_branch?.display_name,
          establishment_company_branch: group?.establishment_branch?.general_information && (
            <div className="flex items-center gap-2">
              <ImageWithPlaceholder
                placeholderIcon={Building2}
                className="w-6 h-6"
                iconClassName="w-4 h-4"
                url={group?.establishment_branch?.general_information?.company_logo?.url}
              />

              <p>
                {group?.establishment_branch?.general_information?.fantasy_name}
              </p>
            </div>
          ),
          consumptions_amount: formatCurrency(Number(group.consumptions_amount || 0)),
          consumptions_count: Number(group.consumptions_count),
          opened_at: group.opened_at ? formatDate(new Date(`${group.opened_at} `)) : '',
          closed_at: group.closed_at ? formatDate(new Date(`${group.closed_at} `)) : '',
          action: (
            <Link to={group.id}>
              <ArrowBigRight />
            </Link>
          ),
          _className: group.status === 'rejected' ? 'bg-yellow-op-2' : '',
        };
      });
    };
  }

  static quickSearchModelTransformer() {
    return (groups: FiscalDocumentGroupData[]) => {
      return groups.map((group) => ({
        route: `/billing-fiscal-document-groups/${group.id}`,
        items: [
          ['Status', group.status ? billingEventsFiscalDocumentsStatus[group.status as keyof typeof billingEventsFiscalDocumentsStatus] : ''],
          ['Estabelecimento', group?.establishment_branch?.general_information?.fantasy_name],
          ['Empresa', group?.client_branch?.general_information?.fantasy_name],
        ]
      }));
    };
  }
}
